import { render, staticRenderFns } from "./thankyou.vue?vue&type=template&id=6b38d52c&"
import script from "./thankyou.vue?vue&type=script&lang=js&"
export * from "./thankyou.vue?vue&type=script&lang=js&"
import style0 from "./thankyou.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b38d52c')) {
      api.createRecord('6b38d52c', component.options)
    } else {
      api.reload('6b38d52c', component.options)
    }
    module.hot.accept("./thankyou.vue?vue&type=template&id=6b38d52c&", function () {
      api.rerender('6b38d52c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/pages/thankyou.vue"
export default component.exports